import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

export const ClientsAddInitializer = (): Initializer => {
  const node = getOrAppendChild({ id: 'clients-add', parentNode: document.body });

  const destroy = () => ReactDOM.unmountComponentAtNode(node);
  const onClose = () => destroy();

  return {
    destroy: () => ReactDOM.unmountComponentAtNode(node),
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="ClientsAdd"
          props={{
            onClose,
          }}
        />,
        node,
      );
    },
  };
};
